import type { AlpineComponent } from 'alpinejs';

type AccordionProps = {
	openItems: number[];
	multiple: boolean;
};

export const accordion = ({
	openItems = [],
	multiple = false
}: AccordionProps): AlpineComponent => ({
	openItems,
	multiple,
	toggle(v) {
		if (this.openItems.includes(v)) {
			this.openItems = this.openItems.filter(el => el !== v);
		} else {
			this.openItems = this.multiple ? [...this.openItems, v] : [v];
		}
	}
});
